/** @format */
import { useState, useCallback, useEffect } from 'react';
import useRWD from '../../hooks/useRwd';
import { useLocation } from 'react-router-dom';
import { getLocalStorageLng } from 'utils/utils';
import { useHistory } from 'react-router-dom';
import { useModal } from '../../modules/ui';
import { useFilter } from '../../modules/dashboard';

export const navbarItems = [
	{
		i18nKey: 'navbar.pages.meetup',
		path: '',
		group: []
	},
	{
		i18nKey: 'navbar.pages.posts',
		path: 'posts',
		group: []
	},
	{
		i18nKey: 'navbar.pages.newuser',
		path: 'newuser',
		group: [
			{
				i18nKey: 'navbar.pages.features',
				path: 'newuser/features',
				items: [
					{
						i18nKey: 'navbar.pages.five',
						path: 'newuser/features/five'
					},
					{
						i18nKey: 'navbar.pages.vip',
						path: 'newuser/features/vip'
					}
				]
			},
			{
				i18nKey: 'navbar.pages.userguide',
				path: 'newuser/userguide',
				items: [
					{
						i18nKey: 'navbar.pages.howto',
						path: 'newuser/userguide/howto'
					},
					{
						i18nKey: 'navbar.pages.qa',
						path: 'newuser/userguide/qa'
					}
				]
			},
			{
				i18nKey: 'navbar.pages.recommend',
				path: 'newuser/recommend',
				items: [
					{
						i18nKey: 'navbar.pages.stayhome01',
						path: 'newuser/recommend/stayhome01'
					},
					{
						i18nKey: 'navbar.pages.stayhome02',
						path: 'newuser/recommend/stayhome02'
					},
					{
						i18nKey: 'navbar.pages.stayhome03',
						path: 'newuser/recommend/stayhome03'
					},
					{
						i18nKey: 'navbar.pages.stayhome04',
						path: 'newuser/recommend/stayhome04'
					},
					{
						i18nKey: 'navbar.pages.stayhome05',
						path: 'newuser/recommend/stayhome05'
					},
					{
						i18nKey: 'navbar.pages.chat01',
						path: 'newuser/recommend/chat01'
					}
				]
			},
			{
				i18nKey: 'navbar.pages.festival',
				path: 'newuser/recommend',
				items: [
					{
						i18nKey: 'navbar.pages.Valentine01',
						path: 'newuser/recommend/Valentine01'
					},
					{
						i18nKey: 'navbar.pages.Valentine02',
						path: 'newuser/recommend/Valentine02'
					},
					{
						i18nKey: 'navbar.pages.Valentine03',
						path: 'newuser/recommend/Valentine03'
					},
					{
						i18nKey: 'navbar.pages.Moon01',
						path: 'newuser/recommend/Moon01'
					},
					{
						i18nKey: 'navbar.pages.taipeimeettop10',
						path: 'newuser/recommend/taipeimeettop10'
					},
					{
						i18nKey: 'navbar.pages.larp',
						path: 'newuser/recommend/larp'
					}
				]
			}
		]
	},
	{
		i18nKey: 'navbar.pages.witness',
		path: 'witness',
		group: []
	},
	{
		i18nKey: 'navbar.pages.aboutus',
		path: 'aboutus',
		group: [
			{
				i18nKey: 'navbar.pages.media',
				path: 'aboutus/media',
				items: []
			},
			{
				i18nKey: 'navbar.pages.community',
				items: [
					{
						i18nKey: 'navbar.pages.ig',
						path: 'https://egapp.us/ig/web'
					},
					{
						i18nKey: 'navbar.pages.fb',
						path: 'https://egapp.us/fb/web'
					},
					{
						i18nKey: 'navbar.pages.yt',
						path: 'https://egapp.us/youtube/web'
					}
				]
			}
		]
	}
];

export const useNavbar = () => {
	const location = useLocation();
	const { size, MD, isXL, isLG } = useRWD();
	const history = useHistory();
	const localizedLang = getLocalStorageLng();
	const [isSearch, setIsSearch] = useState(false);
	const { boundToggleRightSidebar, rightSidebar } = useModal();
	const { boundResetFilter, boundFetchMeetups } = useFilter();

	const isMeetupListPage =
		location.pathname === '/' ||
		location.pathname === `/${localizedLang}` ||
		location.pathname === `/${localizedLang}/`;

	const showUserGroup =
		location.pathname !== `/${localizedLang}/meetup/create` &&
		location.pathname !== `/${localizedLang}/login`;

	const gotoHomeOrRefresh = useCallback(() => {
		const { pathname } = location;
		const isRefreshNeeded =
			pathname === '/' || pathname === `/${localizedLang}/`;
		boundResetFilter();
		boundFetchMeetups();
		if (isRefreshNeeded) {
			history.go();
		}
		history.push(`/${localizedLang}/`);
	}, [localizedLang, location]);

	const toggleSearch = useCallback(() => {
		setIsSearch(!isSearch);
	}, [setIsSearch, isSearch]);

	return {
		size,
		MD,
		isXL,
		isLG,
		rightSidebar,
		isSearch,
		isMeetupListPage,
		showUserGroup,
		localizedLang,
		gotoHomeOrRefresh,
		toggleSearch,
		toggleRightSidebar: boundToggleRightSidebar
	};
};
